export enum CheckoutRoutes {
  serviceLocation = '/',
  checkout = '/checkout',
  summary = '/summary',
  orderConfirmation = '/order-confirmation',
  contactInformation = '/contact-information',
}
